// extracted by mini-css-extract-plugin
module.exports = {"productOverview__section":"ProductOverview_productOverview__section__B4BzD","productOverview__cardTitle":"ProductOverview_productOverview__cardTitle__NtnEC"};